import { render, staticRenderFns } from "./rectificationTime.vue?vue&type=template&id=60c9c5bc&scoped=true"
import script from "./rectificationTime.vue?vue&type=script&lang=js"
export * from "./rectificationTime.vue?vue&type=script&lang=js"
import style0 from "./rectificationTime.vue?vue&type=style&index=0&id=60c9c5bc&prod&scoped=true&lang=scss"
import style1 from "./rectificationTime.vue?vue&type=style&index=1&id=60c9c5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9c5bc",
  null
  
)

export default component.exports